export const getValidLink = (link: string) => {
	return link.startsWith('http://') || link.startsWith('https://') ? link : `//${link}`
}

export const openLink = (url: string): void => {
	const link = document.createElement('a')
	link.href = url
	link.target = '_blank'
	document.body.appendChild(link)
	link.click()
	link.parentNode.removeChild(link)
}

export const isExternalLink = (url: string): boolean => !url.startsWith('/')

export const isNotProdServer = (): boolean =>
	!(window?.location?.hostname ?? '').includes('partners.dasreda.ru')

export const getInfoClient = (): string => {
	return `\n\nИнформация о пользователе:
	Браузер, ОС: ${navigator.userAgent}
	Разрешение экрана: ${window.screen.availWidth} x ${window.screen.availHeight}
	Размер области просмотра: ${window.innerWidth} x ${window.innerHeight}
	Масштаб*: ${window.devicePixelRatio}`
}
